import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stripTags',
  standalone: true
})
export class StripTagsPipe implements PipeTransform {

  transform(value: any): string {
    if (!value || typeof value != 'string') return '';

    // Create a dummy element to parse HTML and extract text
    const div = document.createElement('div');
    div.innerHTML = value;
    return div.textContent || '';
  }

}
